export default "__VITE_ASSET__DIsBiw1C__"